import { Price } from '@/lib/types/bevmaq.types';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  price?: Price;
};

function PriceFormat({ price }: Props) {
  const { locale } = useRouter();
  const { t } = useTranslation();
  const currency_symbols = {
    USD: '$',
    EUR: '€',
  };
  return price?.amount ? (
    <span data-testid='product-price'>
      {Number(price?.amount).toLocaleString(locale, {
        minimumFractionDigits: 0,
      })}{' '}
      <span className='text-xl'>
        {(price.currency && currency_symbols[price.currency]) ?? ''}
      </span>
    </span>
  ) : (
    <span>{t('Price Upon Request')}</span>
  );
}

export default PriceFormat;
